import styled from 'styled-components';

/** Stacking level of the sticky Customize-mode rail pinned above the grid. */
export const CUSTOMIZE_RAIL_Z_INDEX = 10;

/** Full width because the grid measures this element to size itself. */
export const DashboardGrid = styled.div<{ $isEditing: boolean }>`
  width: 100%;
  /* The page layout has no bottom gutter. */
  margin-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  transition: background-color 0.22s ease;

  ${({ $isEditing, theme }) =>
    $isEditing &&
    `
      background:
        radial-gradient(${theme.borderAccentColor} 1.2px, transparent 1.2px) 0 0 / 26px 26px,
        ${theme.tealBackgroundColor};
      outline: 2px dashed ${theme.teal};
      outline-offset: -2px;
    `}

  /* Lift the tile being moved or resized over the sticky rail, which it would
     otherwise slide under (react-grid-layout only raises it to z-index 3). */
  .react-grid-item.react-draggable-dragging,
  .react-grid-item.resizing {
    z-index: ${CUSTOMIZE_RAIL_Z_INDEX + 1};
  }

  .react-grid-item.react-grid-placeholder {
    background: ${({ theme }) => theme.teal};
    opacity: 0.2;
    border-radius: 10px;
  }

  /* Fat teal corner grip (replaces the faint default SVG). */
  .react-resizable-handle {
    width: 27px;
    height: 27px;
    bottom: 0;
    right: 0;
    padding: 0;
    background: none;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(
        135deg,
        transparent 50%,
        ${({ theme }) => theme.tealLightOpacity} 50%
      );
      border-bottom-right-radius: 10px;
    }

    &::after {
      content: '';
      position: absolute;
      right: 4px;
      bottom: 4px;
      width: 14px;
      height: 14px;
      border-right: 3px solid ${({ theme }) => theme.teal};
      border-bottom: 3px solid ${({ theme }) => theme.teal};
      border-bottom-right-radius: 2px;
    }
  }
`;
